import $ from 'jquery';

function resolve(path) {
    // EXT: prefix only works for non-core extensions.
    if (path.substring(0, 4) === 'EXT:') {
        path = path.substring(4);
        while (path.substring(0, 1) === '/') {
            path = path.substring(1);
        }
        path = '/typo3conf/ext/' + path;
    }
    return path;
}


const SelectorUrlMap = {
    '.fa-thin.fa-person-in-canoe': 'EXT:lfmsite/Resources/Public/Icons/person-in-canoe.svg',
    '.fa-thin.fa-tourist-info': 'EXT:lfmsite/Resources/Public/Icons/tourist-info.svg',
}

window.switchIconsOnRoot = function (root) {
    const $root = $(root);
    for (const [selector, url] of Object.entries(SelectorUrlMap)) {
        (function () {
            const $elems = $root.find(selector);
            if ($elems.length > 0) {
                const selectors = selector.split(/[.\s]+/).filter(e => e.trim());
                /** @type {string[]} */
                let classes = Array.from($elems.prop('classList'));
                classes = classes.filter(item => !selectors.includes(item))
                fetch(resolve(url)).then(response => response.text()).then(svg => {
                    const $svg = $('<div></div>').html(svg).children('svg').first();
                    $svg.addClass('inline-svg');
                    for (const cls of classes) {
                        $svg.addClass(cls);
                    }
                    $elems.each(function () {
                        $(this).replaceWith($svg.clone());
                    });
                });
            }
        })();
    }
}

switchIconsOnRoot(document.body);
